import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { YOUTUBE_CHANNEL_ID,YOUTUBE_VIDEO_API_KEY } from '@/config/endpoints';
// import ResourceTab from '@/components/shared/resourceTab';
import { ThreeDots } from 'react-loader-spinner';
import ResourcesLinks from '@/layout/resourcesLinks';
// import MainLayout from '@/layout/mainLayout';
import { SEODATA } from "@/config/seo_config";
import Head from 'next/head';
import IMAGES from '@/public/assets/img';


export const metadata = {
  title: SEODATA.VIDEOSLIST.title,
  description: SEODATA.VIDEOSLIST.description,
  keywords: SEODATA.VIDEOSLIST.keyword,
  alternates: {
    canonical: SEODATA.VIDEOSLIST.url
  },
  
  openGraph: {
    title: SEODATA.VIDEOSLIST.title,
    description: SEODATA.VIDEOSLIST.description,
    url: SEODATA.VIDEOSLIST.url,
    imagePath:IMAGES.HOMEIMG.bigLogoNew.src
  }
};



const Videos = () => {
  const [videos, setVideos] = useState([]);
  const [pageToken, setPageToken] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [videoLength, setVideoLength] = useState('');
  const opts = {
    height: '200',
    width: '100%',
}
  useEffect(() => {
    
    fetchVideos();
    // document.querySelector('iframe').contentWindow.postMessage('text', '*');
    
  }, []);
  const fetchVideos = async () => {
    setIsLoading(true);
  try {
    const response = await axios.get(
      'https://www.googleapis.com/youtube/v3/search', {
        params: {
          part: 'snippet',
          channelId: YOUTUBE_CHANNEL_ID, // Replace with your YouTube channel ID
          maxResults: 12, // Change the number of videos to fetch as needed
          key: YOUTUBE_VIDEO_API_KEY, // Replace with your YouTube Data API key
          pageToken: pageToken,
          order: 'date',
        }
      }
    );
    const newVideos = [...videos,...response.data.items ];
    const newArray = newVideos.filter(obj => obj.etag !== "3NRWE3Vt06OxBU8Il9IhOdGVWXk");
    // newVideos

    setVideos(newArray);
    setVideoLength(newArray.length)
    setPageToken(response.data.nextPageToken);
    setIsLoading(false);
   
  } catch (error) {
    console.error('Error fetching videos:', error);
    setIsLoading(false);
  }
};
  const loadMoreVideos = () => {
    if (isLoading) {
      return;
    }

    // fetchVideos();
  };
  


  const truncateString=(str, maxLength)=> {
    if (str.length <= maxLength) {
      return str; // No truncation needed
    }
  
    // Truncate the string and append an ellipsis
    const truncatedString = str.slice(0, maxLength - 3) + '...';
    return truncatedString;
  }
  const truncatedTitle=(title)=>{
    const originalString = title;
    const maxLength = 80;
    return truncateString(originalString, maxLength);
  }


// console.log('videos',videos)
  return (
    <main className='mt-[100px] mb-10'>
      <Head>  
          <title>{metadata.title}</title>
          <meta name="description" content={metadata.description} />
          <meta name="keywords" content={metadata.keywords} />
          {/* OpenGraph tags */} 
          <meta property="og:title" content={metadata.openGraph.title} />
          <meta property="og:description" content={metadata.openGraph.description} />
          <meta property="og:url" content={metadata.openGraph.url} />
          <meta property="og:image" content={metadata.openGraph.imagePath} />
          <link rel="canonical" href={metadata.alternates.canonical} />
        </Head>
    
        <section className='pt-20 pb-10 bg-white sm:py-10'>
        <div className='container  lg:px-3 xm:px-3 sm:px-2'>
        <ResourcesLinks />
        <ul className="grid gap-3 sm:grid-cols-1 md:grid-cols-3 grid-cols-3">
          {videos.map((video) => (
            <li
              key={video.etag}
              className="col-span-1 flex flex-col list-none bg-white border-[#E6E6E6] shadow-cardShadow2 m-2 hover:shadow-cardHover2 transition-shadow animate-fade-in"
            >
              {/* <YouTube videoId={video.id.videoId} opts={opts} width="100%" height="200px" />
              <h2 className="p-2" dangerouslySetInnerHTML={{ __html: truncatedTitle(video.snippet.title) }} /> */}
              {video.id.kind === "youtube#video" && 
              <div key={video.id.videoId}>
              <iframe
                width={opts.width}
                height={opts.height}
                src={`https://youtube.com/embed/${video.id.videoId}`}
                title={video.snippet.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
              <h3 className="p-2" dangerouslySetInnerHTML={{ __html: truncatedTitle(video.snippet.title) }} />
            </div>
             }
            </li>
          ))}
        </ul>
      </div>
      {isLoading ? (
        <div className='fixed inset-0 z-[9999] items-center flex bg-[rgba(255,255,255,0.8)]'>
        <div className='w-[100px] mx-auto h-[100px] justify-center flex'>
        <ThreeDots 
          height="80" 
          width="80" 
          radius="9"
          color="#D9232D" 
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClassName="m-auto"
          visible={true}
          />
          </div>
        </div>
      ) : (videoLength.length > 12 &&
        <div className='justify-center'><button className='bg-brand border-none block mx-auto h-[40px] text-white px-4 rounded-[5px] mt-4 text-sm' onClick={loadMoreVideos}>Load More</button></div>
      )}
      </section>
    </main>
  );
};

export default Videos;
